import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';

export const TermsOfServicePage = () => {
  return (
    <div className="min-h-screen py-20 px-4 sm:px-6 lg:px-8 bg-[#0B1120] text-white">
      <Helmet>
        <title>Terms of Service | Nitro Logs</title>
        <meta name="robots" content="index, follow" />
      </Helmet>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-5xl mx-auto"
      >
        <div className="mb-10 text-center">
          <p className="text-sm uppercase tracking-widest text-blue-400">Legal</p>
          <h1 className="text-4xl lg:text-5xl font-bold mt-4">Terms of Service</h1>
          <p className="mt-4 text-gray-400 max-w-3xl mx-auto">
            These terms govern your use of the Nitro Logs platform, including account access, purchases, and support.
          </p>
        </div>

        <div className="space-y-10 text-gray-300">
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Acceptance of Terms</h2>
            <p className="leading-relaxed">
              By using Nitro Logs, you agree to these Terms of Service and any additional terms posted on the platform.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">User Accounts</h2>
            <p className="leading-relaxed">
              You are responsible for maintaining the security of your account and for any activity that occurs under your login.
              You must provide accurate registration information and keep it up to date.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Payments and Refunds</h2>
            <p className="leading-relaxed">
              Payments are processed through our supported gateways. Refund requests are handled according to our refund policy and
              may be subject to review.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Prohibited Conduct</h2>
            <ul className="list-disc list-inside space-y-2 leading-relaxed">
              <li>Do not use the platform for illegal or fraudulent activities.</li>
              <li>Do not share access to accounts or services that violate third-party terms.</li>
              <li>Do not attempt to disrupt or abuse the platform.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Limitation of Liability</h2>
            <p className="leading-relaxed">
              Nitro Logs is not liable for indirect or consequential damages arising from your use of the platform.
              Use of the service is at your own risk.
            </p>
          </section>
        </div>
      </motion.div>
    </div>
  );
};
